import { Component, OnInit, ViewChild } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { AbstractComponent } from '../../../../../core/common/component/AbstractComponent';

import { UserIndexService } from './UserIndexService'
import { UserEntryDialogComponent } from './dialog/entry/UserEntryDialogComponent';
import { TenantEntryDialogComponent } from '../../tenant/index/dialog/entry/TenantEntryDialogComponent';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

import { ToastrService } from 'ngx-toastr';
import { GSDialogComponent } from 'src/app/directives/gs-dialog/GSDialogComponent';
// import { AppDialogComponent } from 'src/app/directives/app-dialog/AppDialogComponent';

@Component({
  selector: 'app-user-index',
  templateUrl: './UserIndex.html',
  styleUrls: ['./UserIndex.scss']
})
export class UserIndexComponent extends AbstractComponent {


  public scope = {
    wait : false,
    tenant : {
      tenantName : '',
      tenantCd : '',
      address : '',
      tel : '',
      mainFamilyName : '',
      mainFirstName : '',
      mainPosition : '',
      mainEmail : '',
      logoImage : '',
    }
  }
  tenant: any = {
    tenant_name : '' ,tenant_cd : '' ,address : ''
    ,tel : '' ,main_name : '' ,main_position : '' ,main_email : ''
  };

  tenantCd;
  logoImage;
  dataSource = null;
  displayedColumns: string[] = ['email', 'name', 'position', 'loginStatusCd', 'actions'];


  @ViewChild(MatPaginator,  { static: true }) paginator: MatPaginator;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private service : UserIndexService,
    private toastr: ToastrService
    ) {
      super();
  }

  public componentWillMount() {
    window.scrollTo(0, 0);
//    this.service.get().subscribe(e => { console.log(e)});
    this.route.params.subscribe(params => {
      this.tenantCd = params.tenantCd;
      this.service.getTenant(this.tenantCd).subscribe((res:any) => {
        this.scope.tenant = res;
      })
    });
  }

  public entryUser() {
    const dialogRef = this.dialog.open(UserEntryDialogComponent, {
      data : {
        'tenantCd' : this.tenantCd 
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.render();
    });
  }

  public editUser(user){
    const dialogRef = this.dialog.open(UserEntryDialogComponent, {
      data : {
        'tenantCd' : this.tenantCd,
        'user' : user
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'SUCCESS') {
        this.toastr.success('User update is successful', '', { timeOut: 2000 });
        this.render();
      }      
    });
  }

  public deleteUser(user){
    const dialogRef = this.dialog.open(GSDialogComponent, {
      data: {
        'title' : '実行確認',
        'body' : '選択したユーザを削除します。よろしいですか？',
        buttons : [
          { title : 'Cancel', bool : false },
          { title : 'OK',     bool : true, buttonType : 'submit'}
        ]

        
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.delete(user.id).subscribe((res:any)=>{
          this.toastr.success('User delete is successful', '', { timeOut: 2000 });
          this.render();
        },(err:any)=>{
          console.log(err);
        });

      }
      console.log(result);
    });
    // this.AppYesNoDialogRef.afterClosed().subscribe(result => {
    //   if(result){
    //     this.service.delete(tenantCd, email).subscribe((res:any)=>{
    //       this.render();
    //       console.log(res);
    //     },(err:any)=>{
    //       console.log(err);
    //     });
    //   }
    // });
  }

  public editTenant(){
    const dialogRef = this.dialog.open(TenantEntryDialogComponent, {
      disableClose : true,
      data : {
        'tenant' : this.scope.tenant
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'SUCCESS') {
        this.service.getTenant(this.tenantCd).subscribe((res:any) => {
          this.scope.tenant = res;
          this.toastr.success('Tenant update is successful', '', { timeOut: 2000 });
        })  
      }
    });
  }

  public render() {
    this.service.getUsers(this.tenantCd).subscribe((res: any) => {
      res.map((e) => { 
        e.name = e.familyName + ' ' + e.firstName;
        return e 
      });

      this.dataSource = new MatTableDataSource<any>(res); 
      this.dataSource.paginator = this.paginator;

      this.service.getTenant(this.tenantCd).subscribe((db_record:any) => {
        if (db_record && db_record.length > 0) {
          this.tenant.setDbData(db_record[0]);
          this.tenant.deleteFlgViewValue = this.tenant.deleteFlg;
          this.tenant.adminFlgViewValue = this.tenant.adminFlg;
          this.tenant.deleteFlgOptions.forEach(element => {
            if (this.tenant.deleteFlg == element.value){
              this.tenant.deleteFlgViewValue = element.viewValue;
            }
          });
          this.tenant.adminFlgOptions.forEach(element => {
            if (this.tenant.adminFlg == element.value){
              this.tenant.adminFlgViewValue = element.viewValue;
            }
          });
          this.logoImage = "/gfpadmin/assets/images/GFP_logo.png"
          // this.service.logo(this.tenantCd).subscribe((res:any) => {
          //   this.tenant.setIconData(res)
          //   this.logoImage = this.tenant.iconDataSrc
          // });
        }
      });
    },(err:any)=>{
      console.log(err);
  //    this.loading = false;
    });
  }  
}

